// extracted by mini-css-extract-plugin
module.exports = {"button":"SideNavButton_button__uOlCf","selected":"SideNavButton_selected__3BqHu"};